import styled, { css } from 'styled-components';

export const ViewEventListContainer = styled.div`
    overflow: hidden;

    ${(props) =>
        props.isTerminal &&
        css`
            box-shadow: 0 0 4px 2px rgba(163, 157, 163, 0.2);
            border-radius: 5px;
        `};
`;

export const ListGroupContainer = styled.div`
    ${(props) =>
        props.isTerminal &&
        css`
            box-shadow: 0 0 4px 2px rgba(163, 157, 163, 0.2);
            border-radius: 5px;
            overflow: hidden;
        `};
`;
